import { t as __t } from "i18next";
import React, { useState, useEffect } from "react";
import { useListRefreshListener } from "../../../utils/listNavigation";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { callCancelAgent, checkCancelAgent } from "../../../api/callcenters/service"
import { callGetAllProvince, callSearchAgentInfo, callUploadFile } from "../../../api/settings/service"
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import { encodeBase64, handleGetCookie } from "../../../utils/commonUtil"
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import RecordsTableFilter from "../../../components/table-filter"
import "../../../components/i18n/lang";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../../components/paginations";
import moment from "moment";
import Swal from "sweetalert2";
import colors from '../../../utils/colors'
import { callExportAgent } from "../../../api/export";
import SwalAlert from "../../../components/common/alert";
import { Modal } from "bootstrap";
import FileUploadGrid from "../../../components/upload-file";
import RadioBox from "../../../components/common/radioBox";
import SmartTable from "../../../components/common/table-component";

const Index = () => {
	let baseUrl = "/admin/callcenter/agentService/save";
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [request, setRequest] = useState({ page: 1, maxResult: 10, keyword: '', modifiedCode: '', modifiedName: '', provinceId: '', roleStaff: '' });
	const [agentList, setAgentList] = useState([]);
	const [totalPages, setTotalPages] = useState(1);
	const [totalRecord, setTotalRecord] = useState(1);
	const [provinceList, setProvinceList] = useState([]);
	const [requestCancel, setRequestCancel] = useState({ agentCode: '', typeInsurance: '', type: '', documentPath: '', requestReason: '', carriedCode: '', carriedName: '', file: null, fileValue: null });
	const [selected, setSelected] = React.useState("");


	useEffect(() => {
		const authData = handleGetCookie('auth');
		console.log(authData?.user);
		if (authData?.user?.userId) {
			setRequest((prev) => ({
				...prev,
				modifiedCode: authData?.user?.userId,
				modifiedName: authData?.user?.firstName + " " + (authData?.user?.lastName === null ? '' : authData?.user?.lastName),
				roleStaff: authData?.user?.roleStaff
			}));

			loadData(authData?.user?.roleStaff);
		}
		loadProvince()

	}, [request.page, request.maxResult]);
	const loadProvince = async () => {
		const rsp = await dispatch(callGetAllProvince());
		if (rsp?.payload?.responseCode === "00000") {
			setProvinceList(rsp?.payload?.data)
		}
	}
	const loadData = async (roleStaff) => {
		let data = { page: request.page, maxResult: request.maxResult, keyword: request.keyword, provinceId: request.provinceId, roleStaff: roleStaff };
		const rsp = await dispatch(callSearchAgentInfo(data));
		console.log(rsp)
		if (rsp?.payload?.responseCode === "00000") {
			setAgentList(rsp.payload.data.result);
			setTotalPages(rsp.payload.data.totalPages);
			setTotalRecord(rsp.payload.data.totalRecords)
		}
	};

	const handlePageChange = (pageNumber) => {
		if (pageNumber >= 1 && pageNumber <= totalPages) {
			setRequest((prev) => ({ ...prev, page: pageNumber }));
		}
	};

	const handleChange = (e) => {

		const { name, value } = e.target;
		setRequest((prev) => ({ ...prev, [name]: value }));
	};

	const onSearch = async (e) => {
		e.preventDefault()
		loadData()
	}

	const handleEdit = (id) => {
		navigate(baseUrl + "/" + encodeBase64(id))
	}

	// const handleDelete = (id) => {
	// 	Swal.fire({
	// 		title: t("titleDelete"),
	// 		text: t("confirmDelete"),
	// 		icon: "warning",
	// 		showCancelButton: true,
	// 		confirmButtonColor: colors.confirmMessage,
	// 		cancelButtonColor: colors.cancel,
	// 		confirmButtonText: t('confirm'),
	// 		cancelButtonText: t('cancel')
	// 	}).then(async (result) => {
	// 		if (result.isConfirmed) {
	// 			try {
	// 				const rsp = await dispatch(callCancelAgent({ agentId: id, modifiedCode: request.modifiedCode, modifiedName: request.modifiedName }));
	// 				if (rsp?.payload?.responseCode === "00000") {
	// 					Swal.fire({
	// 						icon: "success",
	// 						title: t("success.delete"),
	// 						confirmButtonColor: colors.confirmMessage,
	// 						confirmButtonText: t('close'),
	// 					}).then(() => {
	// 						loadData();
	// 					});
	// 				}
	// 			} catch (error) {
	// 				Swal.fire("ເກີດຄວາມຜິດພາດ!", "ມີບັນຫາໃນການເຊື່ອມຕໍ່ກັບເຊີບເວີ", "error");
	// 			}
	// 		}
	// 	});
	// }
	const handleSave = async (e) => {
		e.preventDefault()
		if (requestCancel.type === '') {
			SwalAlert.error(t("swal.title.titleReqCancel"), t("agent.cancel.typeRequired"));
			return
		}
		SwalAlert.confirm(t("swal.title.titleReqCancel"), t("swal.text.textReqCancel"), async () => {
			try {
				let error = null;
				let documentPath = null;

				// Upload file if exists
				if (requestCancel.file?.file) {
					const upload = await dispatch(callUploadFile(requestCancel.file.file));
					if (upload?.payload?.responseCode === "00000") {
						documentPath = JSON.stringify(upload?.payload?.data);
					} else {
						error = t('uploadFile.cancalAgent.fileUploadError');
					}
				}

				if (error) {
					SwalAlert.error(__t("uiText.text023"), error);
					return;
				}

				// Compose updated request object
				const updatedRequest = {
					...requestCancel,
					documentPath
				};
				console.log("updatedRequest", updatedRequest);
				const rsp = await dispatch(callCancelAgent(updatedRequest));
				if (rsp?.payload?.responseCode === "00000") {
					const myModal = document.getElementById("canceAgentPopupModal");
					const modal = Modal.getInstance(myModal);
					modal.hide();
				} else {
					SwalAlert.error(__t("uiText.text023"), rsp?.payload?.responseCode + " - " + rsp?.payload?.responseDescription);
				}
			} catch (error) {
				SwalAlert.error(__t("uiText.text023"), error.toString());
			}
		});
	};
	const handleChangeCancel = (e) => {
		const { name, value } = e.target;
		setRequestCancel((prev) => ({
			...prev,
			[name]: value
		})
		);
	};
	const handleImageSelect = (e) => {
		setRequestCancel((prev) => ({
			...prev,
			file: { file: e },
			fileValue: e.files
		}));
	};
	const regCancel = async (e) => {
		{
			const rsp = await dispatch(checkCancelAgent({ agentCode: e.agentCode }));
			if (rsp?.payload?.responseCode == "00000") {
				const modal = new Modal(document.getElementById("canceAgentPopupModal"));
				modal.show(); // ✅ ເປີດ modal ຜ່ານ Bootstrap API


			} else {
				SwalAlert.error(__t("uiText.text023"), t("errors." + rsp?.payload?.responseCode));
				return
			}
			// console.log(e)
			const authData = handleGetCookie('auth');
			setRequestCancel({
				requestReason: '',
				type: 3,
				agentCode: e.agentCode,
				typeInsurance: e.configCommissionId,
				carriedCode: authData?.user?.userId,
				carriedName: authData?.user?.firstName + " " + (authData?.user?.lastName === null ? '' : authData?.user?.lastName),
			})
		}
	};
	// const checkModal = async (e) => {
	// 	const rsp = await dispatch(checkCancelAgent({ agentCode: e.agentCode }));
	// 	if (rsp?.payload?.responseCode !== "00000") {
	// 		SwalAlert.error("ເກີດຄວາມຜິດພາດ!", t("errors." + rsp?.payload?.responseCode));
	// 		return {}
	// 	}
	// 	return { "data-bs-toggle": "modal", "data-bs-target": "#canceAgentPopupModal" }

	// }

	const downloadExcel = async () => {
		try {
			let data = { page: request.page, maxResult: request.maxResult, keyword: request.keyword, reportType: 0, reportValue: null };
			let response = await callExportAgent(data);
			if (response === null) {
				Swal.fire(__t("uiText.text023"), __t("uiText.text025"), "error");
				return
			}
			const url = URL.createObjectURL(response);
			const link = document.createElement("a");
			link.href = url;
			link.download = `agent_${moment().format("YYYYMMDDHHmmss")}.xlsx`;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} catch (error) {
			console.error("❌ Error downloading Excel:", error);
		}
	};

	useListRefreshListener(loadData);

	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<section className="user-dashboard">
				<div className="dashboard-outer">
					<div className="upper-title-box">
						<h4>{t("menu.callcenter.agent")}</h4>

						<div className="group-button-header">
							<button type="button" className="btn btn-primary" onClick={() => navigate(baseUrl)}>
								<i className="fas fa-plus"></i> {t("button.add")}
							</button>
							{/* <button className="btn btn-success" onClick={downloadExcel}>
								<i className="fas fa-file-export"></i> {t("button.exportExcel")}
							</button> */}
						</div>
					</div>

					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<div className="default-form">
											<div className="row">
												<div className="col-md-3">
													<div className="form-group">
														<label>{t('search.keyword')}</label>
														<input
															type="text"
															name="keyword"
															className="form-control-uld"
															placeholder={t('search.keyword') + "..."}
															onChange={handleChange}
															value={request.keyword}
															autoComplete="off"
															required />
													</div>
												</div>
												<div className="col-md-3 form-group">
													<label>{t('search.province')}</label>
													<select className="chosen-single form-select"
														onChange={handleChange}
														name="provinceId"
														value={request.provinceId}
													>
														<option key={0} value={""}>{t("selectedAll")}</option>
														{
															provinceList.map((item) => (
																<option key={item.provinceId} value={item.provinceId}>{item.provinceName}</option>
															))
														}
													</select>
												</div>
												<div className="col-auto auto-button">
													<label style={{ marginTop: 6 }}>&nbsp;</label>
													<button className="theme-btn btn-style-one w-100" onClick={onSearch}>
														<i className="fas fa-search"></i>&nbsp;{t("button.search")}
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>


					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">

										<RecordsTableFilter
											totalRecord={totalRecord}
											perPage={request.maxResult}
											onChange={(e) =>
												setRequest((prev) => ({
													...prev,
													maxResult: Number(e.target.value),
													page: 1,
												}))
											}
										/>

										<SmartTable
											columns={[
												{ labelKey: "callcenter.agent.agentCode", key: "agentCode", style: { minWidth: '150px' } },
												{ labelKey: "callcenter.agent.gender", key: "gender", render: (val) => t('gender.' + val) },
												{ labelKey: "callcenter.agent.firstName", key: "firstName", style: { minWidth: '150px' } },
												{ labelKey: "callcenter.agent.lastName", key: "lastName", style: { minWidth: '150px' } },
												{ labelKey: "callcenter.agent.status", key: "status", render: (val) => val === 1 ? <span className="badge bg-success">{t('status.active')}</span> : <span className="badge bg-danger">{t('status.inActive')}</span> },
												{ labelKey: "callcenter.agent.phone", key: "phone" },
												{ labelKey: "callcenter.agent.isVerify", key: "isVerify", render: (val) => val === 1 ? <span className="badge bg-success">{t('verifyStatus.verify')}</span> : <span className="badge bg-danger">{t('verifyStatus.notVerify')}</span> },
												{ labelKey: "callcenter.agent.agentType", key: "configCommissionId", render: (val) => val == 1 ? t("agentType.life") : val == 2 ? t("agentType.vehicle") : t("agentType.all") },
												{ labelKey: "callcenter.agent.dateOfBirth", key: "dateOfBirth", render: (val) => val ? moment(val).format("DD/MM/YYYY") : '-' },
												{ labelKey: "callcenter.agent.provinceName", key: "provinceName", style: { minWidth: '150px' } },
												{ labelKey: "callcenter.agent.districtName", key: "districtName", style: { minWidth: '150px' } },
												{ labelKey: "callcenter.agent.village", key: "village", style: { minWidth: '150px' } },
												{ labelKey: "callcenter.agent.documentType", key: "documentName" },
												{ labelKey: "callcenter.agent.documentNo", key: "documentNo" },
												{ labelKey: "callcenter.agent.issueDate", key: "issueDate", render: (val) => val ? moment(val).format("DD/MM/YYYY") : '-' },
												{ labelKey: "callcenter.agent.issuePlace", key: "issuePlace" },
												{ labelKey: "callcenter.agent.expiredDate", key: "expiredDate", render: (val) => val ? moment(val).format("DD/MM/YYYY") : '-' },
												{ labelKey: "callcenter.agent.modifiedDate", key: "updatedAt", render: (val) => val ? moment(val).format("DD/MM/YYYY HH:mm:ss") : '-' },
												{ labelKey: "callcenter.agent.modifiedBy", key: "updatedBy" },
											]}
											data={{ result: agentList }}
											rowKey="agentId"
											recordsTableFilter={false}
											customPagination={false}
											showRowNumber={false}
											actions={(item) => (<div>
												<button disabled={item.status != 1} className="btn btn-primary btn-sm" onClick={() => handleEdit(item.agentId)}><i className="fas fa-pen"></i></button>
												&nbsp;
												<button disabled={item.status != 1} className="btn btn-danger btn-sm" onClick={() => regCancel(item)}><i className="fas fa-trash"></i></button>
											</div>)}
										/>

										<CustomPagination
											currentPage={request.page}
											totalPages={totalPages}
											onPageChange={handlePageChange}
											maxVisiblePages={1}
										/>

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<CopyrightFooter />
			<div className="modal fade" id="canceAgentPopupModal">
				<div className="modal-dialog modal-lg modal-dialog-centered login-modal modal-dialog-scrollable">
					<div className="modal-content">
						<button
							type="button"
							className="closed-modal"
							data-bs-dismiss="modal"
						></button>
						{/* End close modal btn */}

						<div className="modal-body">
							{/* <!-- Login modal --> */}
							<div id="login-modal">
								{/* <!-- Login Form --> */}
								<div className="login-form default-form">
									<div className="form-inner">
										<h3>{t("agent.cancel.req")}</h3>
										<form onSubmit={handleSave}>
											<div className="default-form">
												<div className="row">
													<div className="col-md-12 form-group">
														<label>{t('agent.cancel.type')}<span className="text-danger">*</span></label>
														{requestCancel.typeInsurance !== 3 ? <RadioBox
															label={t('agent.cancel.labelType' + requestCancel.typeInsurance)}
															checked={true} name='type'
															value={3}
															onChange={(e) => handleChangeCancel(e)}
														/> :
															<>
																<RadioBox
																	className='col-md-4'
																	label={t('agent.cancel.labelType1')}
																	checked={requestCancel.type === '1'}
																	value={'1'}
																	name='type'
																	onChange={(e) => handleChangeCancel(e)}
																/>
																<RadioBox className='col-md-4'
																	label={t('agent.cancel.labelType2')}
																	checked={requestCancel.type === '2'}
																	value={'2'}
																	name='type'
																	onChange={(e) => handleChangeCancel(e)}
																/>
																<RadioBox className='col-md-4'
																	label={t('agent.cancel.labelType3')}
																	checked={requestCancel.type === '3'}
																	value={'3'}
																	name='type'
																	onChange={(e) => handleChangeCancel(e)}
																/>
															</>
														}
													</div>
													<div className="col-md-12 form-group">
														<label> {t('agent.cancel.cancelDescription')}</label>
														<textarea
															name="requestReason"
															rows="5"
															cols="40"
															value={requestCancel.requestReason}
															onChange={handleChangeCancel}
															placeholder={t('agent.cancel.cancelDescription')}
														/>
													</div>
													<div className="col-12 col-md-12 form-group">
														<label> {t('agent.cancel.cancelFile')} </label>
														<FileUploadGrid
															multiple={false}
															folderName="cancelAgent"
															onChange={(e) => handleImageSelect(e)}
															accept="image/*,application/pdf"
														/>
													</div>
													<div className="col-12 d-flex justify-content-center">
														<div className="m-3">
															<button className="theme-btn btn-style-one w-100" type="submit">
																<i className="fas fa-add"></i>&nbsp;{t("button.save")}
															</button>
														</div>
													</div>
												</div>
											</div>
										</form>
									</div>
								</div>
								{/* <!--End Login Form --> */}
							</div>
							{/* <!-- End Login Module --> */}
						</div>
						{/* En modal-body */}
					</div>
					{/* End modal-content */}
				</div>
			</div>
		</div>
	);
};

export default Index;
